import axios from 'axios'
import { useEffect, useState } from 'react'
import FileViewer from '../../FileViewer';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const UsersInterest = () => {
  const [interests, setInterests] = useState([])
  // console.log("The interests are:",interests)
  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/marketplace/researcher/interest/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        });

        setInterests(response.data); // ✅ FIXED
      } catch (error) {
        console.log('error while fetch interests', error)
      }
    }

    fetchInterests()
  }, [])

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">User Interests</h2>

      <div className="space-y-4">
        {interests.map((item) => (
          <div
            key={item.id}
            className="border rounded-2xl p-4 shadow-sm hover:shadow-md transition"
          >
            <div className="flex justify-between items-center mb-2">
              <p className="font-medium text-gray-800">
                {item.email}
              </p>
              <span
                className={`text-sm px-3 py-1 rounded-full ${
                  item.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : item.status === "accepted"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {item.status}
              </span>
            </div>

            <p className="text-gray-600 text-sm mb-1">
              📞 {item.phone}
            </p>

            <p className="text-gray-700">
              {item.message}
            </p>
            <h1 className="text-lg font-semibold text-gray-900 mb-2 mt-4">For this Opportunity</h1>
             {/* Opportunity Data */}
              <div
             
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col"
            >
      <div className="p-3 border border-gray-200  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {item?.opportunity ? item.opportunity_data?.domain : item.labopportunity_data?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {item?.opportunity ? item.opportunity_data?.collaboration : item.labopportunity_data?.collaboration}
    </span>

    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {item?.opportunity ? item.opportunity_data?.maturity : item.labopportunity_data?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {item?.opportunity ? item.opportunity_data?.visibility : item.labopportunity_data?.visibility}
    </span>
  </div>
</div>
              {/* Media Preview */}
               <FileViewer publication_type={item?.opportunity ? item.opportunity_data?.publication_type : item.labopportunity_data?.publication_type} file={item?.opportunity ? item.opportunity_data?.file : item.labopportunity_data?.file} name={item?.opportunity ? item.opportunity_data?.name : item.labopportunity_data?.name} />
              {/* Content */}
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    {item?.opportunity ? item.opportunity_data?.name : item.labopportunity_data?.name}
                  </h2>
                </div>
                <p className="text-sm text-gray-600 mt-2 flex-grow">
                  {item?.opportunity ? item.opportunity_data?.summary : item.labopportunity_data?.summary}
                </p>
                {/* Button */}
                {/* <button
                  onClick={() => handleViewDetails(publication.id)}
                  className="mt-6 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  View Details
                </button> */}
              </div>
            </div>
            {/* End of Opportunity Data */}
            <p className="text-xs text-gray-400 mt-2">
              {new Date(item.created_at).toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default UsersInterest